import ConfigService from "../services/ConfigService";
import LocalStorageService from "../services/LocalStorageService";
import CoreService from "../services/CoreService";
import IdentityService from "../services/IdentityService";

import ServiceResponse from "../models/ServiceResponse";

import DataTransformManager from "./DataTransformManager";





export default class DataApiManager
{

    constructor(){
        this.configService = new ConfigService();
        this.LocalStorageService = new LocalStorageService();
        this.coreService = new CoreService();
    }

    // returns ServiceResponse
    async onUploadAsJsonRequest(schema, requestData, userSession)
    {
        try
        {
            var historySchemaId = schema.schemaInfo.id;
            //var schema = this.localStorageService.getSchema(historySchemaId);
            var historySchemaVersion = schema.schemaInfo.schemaVersion;
            if (!schema.dataApi?.active)
            {
                return new ServiceResponse(true,  "Schema " + historySchemaId + " does not currently support Data Uploading.");
            }

            var rawDataList = requestData;
            // in the case of the "star" schema, we actually download three files - the base fact file and the two dimensions - category and defects
            var conformedDataResponse = DataTransformManager.transformStarGradedObservations(rawDataList, historySchemaId, schema);
            if (conformedDataResponse.hasError)
            {
                conformedDataResponse.messages.unshift("Schema " + historySchemaId + " does not currently support Data Uploading.");
                return new ServiceResponse(true,  conformedDataResponse.messages);
            };
            // now get a flat version 
            var flatDataResponse = DataTransformManager.transformGradedObservations(rawDataList, historySchemaId, schema, true);
            if (flatDataResponse.hasError)
            {
                flatDataResponse.messages.unshift("There was a problem generating your flat data upload. Please report the following error to your Application Administrator: ");
                return new ServiceResponse(true,  flatDataResponse.messages);
            };
            // there's only a single file! Push that onto our stack
            conformedDataResponse.data.push(flatDataResponse.data[0]);

            // startTypes are "fact", "childfact" and dimension. childfact and dimension have different structures so should be posted separately.
            var resultMessages = [];
            for (const dataset of conformedDataResponse.data) 
            {
                var postBatch = {
                    Id: IdentityService.makeUuid(),
                    Gcid: userSession.gcid,
                    Schemaid: historySchemaId,
                    SchemaVersion: historySchemaVersion,
                    StorageSchema: dataset.tableType,
                    ObservationFacts: []
                };
                for (const d of dataset.data) 
                {
                    switch (dataset.starType)
                    {
                        case "fact":
                            postBatch.ObservationFacts.push({observationId: d.id, factKey: d.factKey, snapshot: JSON.stringify(d)});
                            break;
                        case "childFact":
                            postBatch.ObservationFacts.push({observationId: d.id, factKey: d.factKey, factType: d.categoryKey, snapshot: JSON.stringify(d)});
                            break;
                        case "dimension":
                            // don't generate dimensions
                            break;
                        default:
                            // this shouldn't happen. TBD - error-handling. 
                    }
                }
                var uploadResponse = {"httpStatusCode": "", "hasError": false, "messages": [], "dataResult": null};
                switch (dataset.starType)
                {
                    case "fact":
                        uploadResponse = await this.coreService.postObservationFactBatch(postBatch, userSession.gcid, userSession.token);
                        break;
                    case "childFact":
                        uploadResponse = await this.coreService.postObservationFactChildBatch(postBatch, userSession.gcid, userSession.token);
                        break;
                    case "dimension":
                        // TBD
                        break;
                    default:
                        // this shouldn't happen. TBD - error-handling. 
                }
                if (uploadResponse.hasError)
                {
                    console.log("Problem uploading dimension.");
                    console.info(uploadResponse);
                    console.info(postBatch);
                    uploadResponse.messages.unshift( "There was a problem uploading dimensional data for the " + dataset.type + " dimension. Please report the following error to your Application Administrator: ");
                    return new ServiceResponse(true, uploadResponse.messages);
                }
                else 
                {
                    console.log("Uploaded " + dataset.StorageSchema + " successfully.");
                    uploadResponse.messages.forEach((m) => {
                        resultMessages.push(m);
                    });

                }
            };
            return new ServiceResponse(false, uploadResponse.messages);
        }
        catch(e)
        {
            var msgs = [];
            msgs.push(e.message);
            msgs.unshift("There was a problem uploading data. Please report the following error to your Application Administrator: ");
            return new ServiceResponse(true, msgs);
        }
    }


    // returns ServiceResponse
    async onUploadDimensionsAsJsonRequest(schema, userSession)
    {
        try
        {
            var historySchemaId = schema.schemaInfo.id;
            //var schema = this.localStorageService.getSchema(historySchemaId);
            var historySchemaVersion = schema.schemaInfo.schemaVersion;
            if (!schema.dataApi?.active)
            {
                return new ServiceResponse(true, "Schema " + historySchemaId + " does not currently support Data Uploading.");
            }

            var conformedDataResponse = DataTransformManager.transformStarGradedDimensions(historySchemaId, schema);
            if (conformedDataResponse.hasError)
            {
                conformedDataResponse.messages.unshift( "There was a problem generating your dimensions data upload. Please report the following error to your Application Administrator: ");
                return new ServiceResponse(true, conformedDataResponse.messages);
            };
            // startTypes are "fact", "childfact" and dimension. childfact and dimension have different structures so should be posted separately.
            var successMessages = [];
            for (const dataset of conformedDataResponse.data) 
            {
                var postBatch = {
                    Id: IdentityService.makeUuid(),
                    Gcid: userSession.gcid,
                    Schemaid: historySchemaId,
                    SchemaVersion: historySchemaVersion,
                    DimLevel: dataset.dimLevel,
                    StorageSchema: dataset.type,
                    StorageFormat: "json",
                    ObservationDims: []
                };
                for (const d of dataset.data) 
                {
                    postBatch.ObservationDims.push({dimKey: d.dimKey, snapshot: JSON.stringify(d)});
                }
                var uploadResponse = await this.coreService.postObservationDimensionBatch(postBatch, userSession.gcid, userSession.token);

                if (uploadResponse.hasError)
                {
                    uploadResponse.unshift("There was a problem uploading dimensional data for the " + dataset.type + " dimension. Please report the following error to your Application Administrator: ");
                    return new ServiceResponse(true, uploadResponse.messages);
                }
                else 
                {
                    successMessages.push(dataset.dimLevel + " Dimensions uploaded successfully.");
                }
            };
            return new ServiceResponse(false, successMessages);
        }
        catch(e)
        {
            var msg = [];
            msg.push(e.message);
            msg.unshift("There was a problem uploading data. Please report the following error to your Application Administrator: ");
        }
    }



}


